export { StatusPageList } from './List'
export { StatusPageDetail } from './Detail'
